import React, { Component, PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { getCartItems, getSubTotal, getEntitlement, getLocale } from 'rootReducer'

import { CartLinks } from './../Cart'
import CartDetailsComponent from './CartDetailsComponent'
import * as cartActions from '../actions'

class CartDetails extends PureComponent {
  static propTypes = {
    cartActions: PropTypes.object,
    cartItems: PropTypes.array.isRequired,
    subTotal: PropTypes.number,
    entitlement: PropTypes.object,
    locale: PropTypes.string,
  }
  handleClick = () => {
    this.props.cartActions.proceedToPayment()
  }

  render() {
    return (
      <CartDetailsComponent
        cartItems={this.props.cartItems}
        handleClick={this.handleClick}
        subTotal={this.props.subTotal}
        entitlement={this.props.entitlement}
        locale={this.props.locale}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  cartActions: bindActionCreators(cartActions, dispatch),
})

const mapStateToProps = state => ({
  cartItems: getCartItems(state),
  subTotal: getSubTotal(state),
  entitlement: getEntitlement(state),
  locale: getLocale(state),
})

export const CartDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(CartDetails)



// WEBPACK FOOTER //
// ./src/containers/Cart/CartDetails/CartDetailsContainer.js